import React from 'react'
import PropTypes from 'prop-types'
import {find, isEmpty} from 'lodash'

import {
    formatAnswer, formatSpreadsheet, formatVote
} from './utils'


function AnswerOld({selected_stream_entity, selected_challenge_stream_entity}) {
    function renderAnswerRow(key, formatted_answer) {
        return (
            <div key={key} className="stream-answer-row">
                {formatted_answer}
            </div>
        )
    }

    function renderAnswers() {
        const render_content = []
        const {answers, votes, user_spreadsheets} = selected_stream_entity
        const {polls} = selected_challenge_stream_entity

        if (!isEmpty(polls)) {
            const vote = find(votes, (v) => v.poll_id === polls[0].id)
            if (vote) {
                render_content.push(
                    renderAnswerRow(`vote_${vote.id}`, formatVote(vote))
                )
            }
        }

        if (!isEmpty(user_spreadsheets)) {
            user_spreadsheets.map(user_spreadsheet => {
                render_content.push(
                    renderAnswerRow(`spreadsheet_${user_spreadsheet.id}`, formatSpreadsheet(user_spreadsheet))
                )
            });
        }

        if (!isEmpty(answers)) {
            answers.map((answer) => {
                render_content.push(
                    renderAnswerRow(`answer_${answer.id}`, formatAnswer(answer))
                )
            })
        }

        return render_content
    }

    return (
        <div className="byquestion-stream-answer">
            {renderAnswers()}
        </div>
    );
}

AnswerOld.propTypes = {
    selected_stream_entity: PropTypes.object.isRequired,
    selected_challenge_stream_entity: PropTypes.object.isRequired,
}

export default AnswerOld
